export
const name: string = "SsaoMrt";

export
const preproc: string = `
	#ifdef WEBGL2
	layout(location = 0) out highp vec4 gbuf_position;
	layout(location = 1) out highp vec4 gbuf_normal;
	#else
	#extension GL_EXT_draw_buffers : require
	#endif
`;

export
const declaration: string = ``;

export
const varyings: string = `
	varying vec3 	v_position;
	varying vec3 	v_normal;
	varying float 	v_visibility;
`;

export
const implementation: string = `
	void main(void)
	{
		if (v_visibility < 0.5) {
			discard;
		}

	#ifdef WEBGL2
	    gbuf_position = vec4(v_position, 1.0);
	    gbuf_normal = vec4(v_normal, 1.0);
	#else
	    gl_FragData[0] = vec4(v_position, 1.0);
	    gl_FragData[1] = vec4(v_normal, 1.0);
	#endif

	#ifdef LOGDEPTH
	    resolveLogarithmicDepth();
	#endif
	}
`;
